import { INDIAN_STATES } from "../../../utils/indianStates";
import { SchoolProfile } from "./schoolProfileService";

// The same rules as the backend's SchoolProfileDto
export type SchoolProfileErrors = Partial<Record<keyof SchoolProfile, string>>;

export const LOGO_MAX_BYTES = 1024 * 1024; // 1 MB, as SchoolLogoStorage
export const LOGO_TYPES = ["image/png", "image/jpeg"];

const required = (value: string | null | undefined, label: string) => (!value?.trim() ? `${label} is required` : undefined);
const maxLength = (value: string | null | undefined, max: number, label: string) =>
  (value?.trim().length ?? 0) > max ? `${label} can be at most ${max} characters` : undefined;

export const validateSchoolProfile = (p: SchoolProfile): SchoolProfileErrors => {
  const errors: SchoolProfileErrors = {
    name: required(p.name, "School name") ?? maxLength(p.name, 150, "School name"),
    addressLine1: required(p.addressLine1, "Address line 1") ?? maxLength(p.addressLine1, 150, "Address line 1"),
    addressLine2: maxLength(p.addressLine2, 150, "Address line 2"),
    city: required(p.city, "City") ?? maxLength(p.city, 80, "City"),
    state: required(p.state, "State") ?? (INDIAN_STATES.includes(p.state.trim()) ? undefined : "Choose a state or union territory of India"),
    pincode: required(p.pincode, "Pincode") ?? (/^\d{6}$/.test(p.pincode.trim()) ? undefined : "Pincode must be 6 digits"),
    phone: p.phone?.trim() && !/^[6-9]\d{9}$/.test(p.phone.trim()) ? "Phone must be 10 digits starting with 6, 7, 8 or 9" : undefined,
    email:
      p.email?.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email.trim())
        ? "Email is not valid"
        : maxLength(p.email, 120, "Email"),
  };
  return Object.fromEntries(Object.entries(errors).filter(([, message]) => message)) as SchoolProfileErrors;
};

export const validateLogoFile = (file: File): string | null => {
  if (!LOGO_TYPES.includes(file.type)) return "The logo must be a PNG or JPG image";
  if (file.size > LOGO_MAX_BYTES) return "The logo must be 1 MB or smaller";
  return null;
};
